//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import API from "~/api/api";
import aos from "~/mixins/aos.js";
import foretell from "~/mixins/foretell.js";
import schemaHelpers from "~/mixins/schema-helpers.js";

export default {
  mixins: [aos, foretell, schemaHelpers],
  mounted() {
    if (process.client) {
      this.createOrLoadUserWithForetellEvent("lnd", {
        lander_test: "bp:personal-affairs",
      });
    }
  },
  head() {
    if (this.pageInfo && this.metaInfo) {
      let domain = "https://www.legalnature.com";
      let canonicalLink = domain;
      let meta = [
        { name: "description", content: this.metaInfo.description },
        { name: "keyword", content: this.metaInfo.keyword },
        { name: "og:image", content: this.metaInfo["og-image"] },
        { name: "og:title", content: this.metaInfo.title },
        { name: "og:description", content: this.metaInfo.description },
        { name: "og:type", content: "website" },
        { name: "og:url", content: canonicalLink },
      ];
      return {
        title: this.metaInfo.title,
        meta,
        link: [
          {
            rel: "canonical",
            href: canonicalLink,
          },
        ],
      };
    } else {
      return {};
    }
  },
  jsonld() {
    if (this.pageInfo && this.metaInfo) {
      return [
        {
          "@context": "https://schema.org",
          "@type": "WebPage",
          mainEntityOfPage: {
            "@type": "WebPage",
            "@id": "https://www.legalnature.com/personal-affairs",
          },
          headline: this.metaInfo.title,
          description: this.metaInfo.description,
          keywords: this.metaInfo.keyword,
          image: this.metaInfo["og-image"],
          url: "https://www.legalnature.com/personal-affairs",
          author: this.schemaAuthor,
          logo: this.schemaLogo,
          publisher: {
            "@type": "Organization",
            name: "LegalNature",
            logo: this.schemaLogo,
          },
        },
        {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Homepage",
              item: "https://www.legalnature.com/",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "Personal Affairs",
              item: "https://www.legalnature.com/personal-affairs",
            },
          ],
        },
      ];
    }
  },
  asyncData({ app, query, params, redirect, error }) {
    return Promise.all([
      API.butterPages.get(app.$axios, "new-personal-affairs", {
        preview: query.preview ? 1 : 0,
      }),
    ])
      .then((results) => {
        const pageInfo = results[0];

        return {
          pageInfo,
          loading: false,
          error: false,
        };
      })
      .catch((e) => {
        console.log(e);
        error({ message: "Error fetching data..." });
        return {
          loading: false,
          // error: true,
        };
      });
  },
  computed: {
    hasSubscriptionAccess() {
      return this.$store.state.user.data.subscriptionAccess;
    },
    hero() {
      if (this.pageInfo && this.pageInfo.fields)
        return this.pageInfo.fields.hero;
    },
    poa() {
      if (this.pageInfo && this.pageInfo.fields)
        return this.pageInfo.fields.poa;
    },
    healthcare() {
      if (this.pageInfo && this.pageInfo.fields)
        return this.pageInfo.fields.healthcare;
    },
    marriage() {
      if (this.pageInfo && this.pageInfo.fields)
        return this.pageInfo.fields.marriage;
    },
    other() {
      if (this.pageInfo && this.pageInfo.fields)
        return this.pageInfo.fields.other;
    },
    resources() {
      if (this.pageInfo && this.pageInfo.fields)
        return this.pageInfo.fields.resources_new;
    },
    footercta() {
      if (this.pageInfo && this.pageInfo.fields)
        return this.pageInfo.fields.footer_cta;
    },
    metaInfo() {
      if (this.pageInfo && this.pageInfo.fields)
        return this.pageInfo.fields.meta_information.table;
    },
  },
};
